module.exports = __webpack_public_path__ + "static/media/picture3.6a0ad8e8.png";